




import { Component, Prop, Vue } from 'vue-property-decorator'
@Component
export default class BaseLogo extends Vue {
    @Prop({ type: Boolean }) dark!: boolean
    @Prop({ type: Boolean }) horizontal!: boolean

    get isMondrian() {
        return true
    }

    get srcAttr() {
        if (this.isMondrian) {
            if (this.horizontal) {
                if (this.dark) {
                    return require('@/assets/images/logo/logo_ff_large_dark.mondrian.svg')
                }

                return require('@/assets/images/logo/logo_ff_large.mondrian.svg')
            } else {
                if (this.dark) {
                    return require('@/assets/images/logo/logo_ff_small_dark.mondrian.svg')
                }

                return require('@/assets/images/logo/logo_ff_small.mondrian.svg')
            }
        } else {
            const size = this.horizontal ? 'horizontal' : 'minimal'
            const color = this.dark ? '-blue' : ''

            return `/build/v2/img/logo-${size}${color}-2x.png`
        }
    }
}
